(function () {
    'use strict';
    angular.module('emarket.store.search')
    .controller('StoreSearchController', ['$scope', '$rootScope', '$location', '$state', '$log', 'Post', 'profile', function ($scope, $rootScope, $location, $state, $log, Post, profile) {
        var vm = this;

        $rootScope.$emit('$locationChangeSuccess');
        vm.filteringCondition = {};
        vm.filteringCurrency = {};
        var sort;
        // var getPricesLimit = function (posts) {
        //     var min;
        //     var max;
        //     min = posts.reduce(function (a, b) {
        //         return a.prices.list > b.prices.list ? b : a;
        //     }, {
        //         prices: {
        //             list: Number.POSITIVE_INFINITY
        //         }
        //     });
        //
        //     max = posts.reduce(function (a, b) {
        //         return a.prices.list > b.prices.list ? a : b;
        //     }, {
        //         prices: {
        //             list: Number.NEGATIVE_INFINITY
        //         }
        //     });
        //     return {
        //         min: min.prices.list,
        //         max: max.prices.list
        //     };
        // };
        var loadFilter = function() {
            var search = $location.search();
            vm.fromPrice = parseInt(search.fromPrice);
            vm.toPrice = parseInt(search.toPrice);
            if(search.condition) {
                vm.filteringCondition[search.condition] = true;
            }
            if(search.currency) {
                vm.filteringCurrency[search.currency] = true;
            }
        };
        loadFilter();
        vm.applyFilter = function(key, value, remove) {
            $log.debug('applying filter', key, value, remove);
            if(remove === true) {
                $location.search(key, null);
            } else {
                $location.search(key, value);
            }
        };
        vm.clearPrice = function() {
            vm.toPrice = null;
            vm.fromPrice = null;
            vm.applyFilter('fromPrice', null);
            vm.applyFilter('toPrice', null);
        };
        vm.filterPrice = function(fromPrice, toPrice) {
            vm.applyFilter('fromPrice', fromPrice);
            vm.applyFilter('toPrice', toPrice);
        };
        vm.makeSort = function() {
            vm.sort = vm.sort || null;
            $location.search('orden', vm.sort);
        };
        function search() {
            var term = Object.assign({}, $location.search());
            term.username = profile.username;
            term.$populate = 'category';
            if(term.orden) {
                term.$sort = term.orden;
                delete term.orden;
            }
            vm.q = term.q;
            Post.$search(term).$asPromise().then(function (results) {
                vm.posts = results;
                vm.metadata = results.$metadata;

                if(!term.condition) {
                    vm.metadata.filter.conditions.forEach(function(filter) {
                        vm.filteringCondition[filter.condition] = false;
                    });
                }
                if(!term.currency) {
                    vm.metadata.filter.currencies.forEach(function(filter) {
                        vm.filteringCondition[filter.currency] = false;
                    });
                }
        // var pricesLimit = getPricesLimit(vm.posts);
        // vm.prices = pricesLimit;
        // vm.fromPrice = pricesLimit.min;
        // vm.toPrice = pricesLimit.max;
            }).catch(function (err) {
                $log.error(err);
            });
        }
        search();
        var ev = $rootScope.$on('$locationChangeSuccess', function() {
            search();
        });
        var changeQuery = function (query) {
            query = query || {};
            Object.keys(query).forEach(function (key) {
                $location.search(key, query[key]);
            });

        };
        vm.updatePrice = function () {
            changeQuery({
                fromPrice: vm.fromPrice,
                toPrice: vm.toPrice
            });
        };
        $scope.$on('$destroy', function() {
            ev();
        });

    }]);
}());
